import AdminSearchesPage from './AdminSearchesPage';

export default AdminSearchesPage;
